import { render, staticRenderFns } from "./Patient.vue?vue&type=template&id=9e0b1f06&scoped=true"
import script from "./Patient.vue?vue&type=script&lang=js"
export * from "./Patient.vue?vue&type=script&lang=js"
import style1 from "./Patient.vue?vue&type=style&index=1&id=9e0b1f06&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e0b1f06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e0b1f06')) {
      api.createRecord('9e0b1f06', component.options)
    } else {
      api.reload('9e0b1f06', component.options)
    }
    module.hot.accept("./Patient.vue?vue&type=template&id=9e0b1f06&scoped=true", function () {
      api.rerender('9e0b1f06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/health/Patient.vue"
export default component.exports